import React from "react";
import { Box, HStack, VStack, Skeleton } from "native-base";

const CARD_BG = "#fff";
const BORDER = "rgba(0,0,0,0.08)";

function SkeletonPlanoCard({ comBadge }: { comBadge?: boolean }) {
  return (
    <Box
      borderRadius="2xl"
      bg={CARD_BG}
      borderWidth={1}
      borderColor={BORDER}
      overflow="hidden"
    >
      {comBadge ? (
        <Box alignSelf="flex-start" pl={0} pt={0}>
          <Skeleton h="8" w="36" borderBottomRightRadius="lg" />
        </Box>
      ) : null}
      <VStack px={3} pt={comBadge ? 3 : 4} pb={3} space={3}>
        <VStack space={2} alignItems="center" mt={comBadge ? 0 : 1}>
          <Skeleton h="4" w="72%" rounded="md" />
          <Skeleton h="4" w="55%" rounded="md" />
        </VStack>

        <VStack space={2} alignItems="center">
          <Skeleton h="8" w="48%" rounded="md" />
          <Skeleton h="3" w="40%" rounded="sm" />
        </VStack>

        <Box h="1px" bg="#D9D5D0" w="100%" opacity={0.85} alignSelf="center" />

        <VStack space={2} alignItems="flex-start" w="100%" pl={1}>
          <Skeleton h="3" w="28%" rounded="sm" />
          <Skeleton h="3" w="70%" rounded="sm" />
        </VStack>

        <Box h="1px" bg="#D9D5D0" w="100%" opacity={0.85} alignSelf="center" />

        <Skeleton h="3" w="88%" rounded="sm" alignSelf="center" />

        <Skeleton h="12" w="100%" rounded="full" mt={1} />
      </VStack>
    </Box>
  );
}

/**
 * Placeholder do layout da tela Assinaturas (filtros por atendente + cards de plano).
 * O aviso superior vem do `Template` via `messageAlerta`.
 */
export default function SkeletonAssinaturas() {
  return (
    <VStack space={5} w="100%" pb={6} px={1}>
      <HStack
        space={4}
        alignItems="flex-start"
        justifyContent="center"
        flexWrap="wrap"
      >
        {[0, 1, 2].map((i) => (
          <VStack key={i} alignItems="center" space={2}>
            <Skeleton w="16" h="16" borderRadius="full" />
            <Skeleton h="2" w="16" rounded="sm" />
          </VStack>
        ))}
      </HStack>

      <SkeletonPlanoCard comBadge />
      <SkeletonPlanoCard />
    </VStack>
  );
}
